import Spin from './Loading';
export default Spin;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-spin/src/index.js